import Sidebar from './SideBar.vue';
import SidebarItem from './SidebarItem.vue';

// The folded or expanded choice is remembered per device (kept across sign out).
export const SIDEBAR_MINIMIZED_KEY = 'sidebarMinimized';

const SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize() {
    // The body class is the source of truth; the flag mirrors it
    const next = !document.body.classList.contains('sidebar-mini');
    document.body.classList.toggle('sidebar-mini', next);
    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(() => {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(() => {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = next;
    try {
      localStorage.setItem(SIDEBAR_MINIMIZED_KEY, next ? '1' : '0');
    } catch (e) { /* storage unavailable: the choice just is not remembered */ }
  },
  // Applies the last choice on this device (expanded when none is saved). Idempotent, so
  // the layout mount, window resizes and the sign-in pages can all call it. Folding only
  // exists from 1200px: below that the sidebar is the off-canvas drawer, where the theme's
  // sidebar-mini rules would hide the menu labels, so the class is left off there.
  restoreMinimize() {
    let saved = null;
    try {
      saved = localStorage.getItem(SIDEBAR_MINIMIZED_KEY);
    } catch (e) { /* storage unavailable */ }
    const want = saved === '1' && window.innerWidth >= 1200;
    document.body.classList.toggle('sidebar-mini', want);
    this.isMinimized = want;
  }
};

const SidebarPlugin = {
  install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    let app = new Vue({
      data: {
        sidebarStore: SidebarStore
      }
    });
    Vue.prototype.$sidebar = app.sidebarStore;
    Vue.component('side-bar', Sidebar);
    Vue.component('sidebar-item', SidebarItem);
  }
};

export default SidebarPlugin;
